<ui-card type="clear">

    <card-header class="pt-2">
        <button id="btn_1581716872" ui-button (click)="onBack()"class="p-0">
            <span class="connect_icon_arrow_back"></span>
            <span class="ml-1 medium uppercase">{{'notifications.back.button' | translate}}</span>
        </button>
        <button id="btn_1581716894" ui-button icon class="ml-auto" (click)="deleteNotification()">
            <span class="connect_icon_remove size-2x"></span>
        </button>
    </card-header>

    <card-header class="bordered">
        <div class="card-details">
            <h5 id="h_1576080852" class="title strong text-black">{{notification.interface.title}}</h5>
            <div class="row align-items-center mt-2 flex-nowrap">
                <div id="div_1576081377" class="col" *ngIf="notification?.interface?.device_status?.icon !== 0" [ngClass]="notification?.interface?.device_status?.icon === 1 ? 'color-success' : 'color-danger'">
                    <div class="d-flex align-items-center">
                        <span class="lead mr-1" [ngClass]="notification?.interface?.device_status?.icon === 1 ? 'connect_icon_protected' : 'connect_icon_unprotected'"></span>
                        <span *ngIf="notification?.interface?.device_status.text" class="ellipsis">{{notification.interface.device_status.text | translate}}</span>
                    </div>
                </div>
                <div class="col-auto" *ngIf="notification?.interface?.user_name">
                    <div class="d-flex align-items-center">
                        <ui-avatar [avatar]="notification.interface.user_avatar" size="36" bg="primary-5"></ui-avatar>
                        <!-- > aici cred ca e o problema  -->
                        <span class="ml-1 ellipsis" [ngClass]="!notification?.interface?.device_status.text ? 'order-last ml-1' : 'mr-1'">{{notification.interface.user_name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </card-header>

    <card-body>
        <div>
            <span class="color-shade-60">{{notification.app_fields.timestamp | localizedDate: 'mediumDateHourMin'}}</span>
            <p id="p_1576238520" *ngIf="notification.interface.desc_threat" class="lead mt-2 mb-0 strong">{{notification.interface.desc_threat | translate: notification.interface.placeholders}}</p>
            <p id="p_1576238518" *ngIf="notification.interface.desc_title" class="lead mt-2 mb-0 text-black strong">{{notification.interface.desc_title | translate: notification.interface.placeholders}}</p>
            <p id="p_1576238535" class="mt-0" [innerHTML]="notification.interface.desc | translate: notification.interface.placeholders"></p>
            <p id="p_1576238519" *ngIf="notification.interface.desc_device" class="mt-2 mb-2" [innerHTML]="notification.interface.desc_device | translate: notification.interface.placeholders"></p>
        </div>

        <div *ngIf="(!notificationtipsAreAnArray && notification.interface.tips) || (notificationtipsAreAnArray && notification.interface.tips?.length)">
            <p id="p_1577462947" *ngIf="notification.interface.tips_title" class="mb-0 text-black strong">{{notification.interface.tips_title | translate: notification.interface.placeholders}}</p>

            <ng-container *ngIf="notificationtipsAreAnArray">
                <p id="p_1577462965" class="mt-0 mb-1 word-break">
                    <ng-container *ngFor="let tip of notification.interface.tips">
                        <div [innerHTML]="tip.text | translate: tip.placeholders"></div>
                    </ng-container>
                </p>

            </ng-container>
            <p *ngIf="!notificationtipsAreAnArray" id="p_1577462965" class="mt-0 mb-1 word-break" [innerHTML]="notification.interface.tips | translate: notification.interface.placeholders"></p>

            <a id="a_1577462980" *ngIf="notification.interface.link" [href]="notification.interface.link" class="no-underline text-highlight">
                <span id="span_1577463188">{{notifications.read.more | translate}}</span>
            </a>
        </div>

            <card-footer class="top-bottom-shadowed p-0">
                <div *ngIf="notification.interface.main_link" class="p-3 d-flex">
                    <ui-icon id="thumb_1577694812" type="action" icon="lock" shape="circle" size="48" class="mr-1" bg="primary-5" ></ui-icon>
                    <div class="ml-1">
                        <p id="p_1577694826" class="m-0 mb-1 b2" [innerHTML]="notification.interface.main_link_desc | translate: notification.interface.placeholders"></p>
                        <a id="a_1577694834"
                        (click)="callSpecificFunction(notification.interface.main_link_funct)"
                        class="p-0 color-danger pointer">{{notification.interface.main_link | translate: notification.interface.placeholders }}
                        </a>
                    </div>
                </div>

                <div class="p-3" *ngIf="notification.interface.main_button">
                    <button id="btn_1576248008" ui-button color="primary" [disabled]="notification.interface.main_button_disabled"
                        (click)="callSpecificFunction(notification.interface.main_button_funct)">
                        {{notification.interface.main_button | translate: notification.interface.placeholders}}
                    </button>
                    <p id="p_1577719266" class="color-shade-60 mt-2" *ngIf="notification.interface.main_button_desc">{{notification.interface.main_button_desc | translate: notification.interface.placeholders}}</p>
                </div>

                <div class="p-3" *ngIf="notification.interface.secondary_button">
                    <button id="btn_1576248031" ui-button model="outline" color="primary" [disabled]="notification.interface.secondary_button_disabled"
                        (click)="callSpecificFunction(notification.interface.secondary_button_funct)">
                        {{notification.interface.secondary_button | translate: notification.interface.placeholders }}
                    </button>
                    <p class="color-shade-60 mt-2" *ngIf="notification.interface.secondary_button_desc">{{notification.interface.secondary_button_desc | translate: notification.interface.placeholders}}</p>
                </div>

                <div *ngIf="notification.interface.noActionNeededDesc" class="p-3 d-flex">
                    <ui-icon type="general" icon="mark" shape="circle" size="48" class="mr-1" bg="primary-5" ></ui-icon>
                    <div class="ml-1">
                        <p class="m-0 mb-1" [innerHTML]="notification.interface.noActionNeededDesc | translate: notification.interface.placeholders"></p>
                    </div>
                </div>

            </card-footer>

    </card-body>


</ui-card>
